import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { trackPageView } from "@/lib/gtag";
import { useContentProtection } from "@/lib/useContentProtection";
import { Toaster } from "sonner";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { FavoritesProvider } from "@/context/FavoritesContext";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import AuthCallback from "@/components/AuthCallback";
import ProtectedRoute from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import Properties from "@/pages/Properties";
import PropertyDetail from "@/pages/PropertyDetail";
import PostProperty from "@/pages/PostProperty";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import Enquiries from "@/pages/Enquiries";
import Privacy from "@/pages/Privacy";import Terms from "@/pages/Terms";
import Dashboard from "@/pages/Dashboard";
import Admin from "@/pages/Admin";
import Shortlist from "@/pages/Shortlist";
import Stays from "@/pages/Stays";
import StayManage from "@/pages/StayManage";
import RentPay from "@/pages/RentPay";
import Rentals from "@/pages/Rentals";
import Collections from "@/pages/Collections";
import PublicMenu from "@/pages/PublicMenu";
import NotFound from "@/pages/NotFound";
import CityLanding from "@/pages/CityLanding";
import Landing from "@/pages/Landing";
import TenantOnboard from "@/pages/TenantOnboard";

function AppRouter() {
  const location = useLocation();
  useContentProtection();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  // ad landing pages render standalone — no navbar or footer to click away with
  if (location.pathname.startsWith("/lp/"))
    return (
      <Routes>
        <Route path="/lp/:slug" element={<Landing />} />
      </Routes>
    );

  return (
    <>
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/properties" element={<Properties />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/join/:token" element={<TenantOnboard />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/pay/:token" element={<RentPay />} />
          <Route path="/menu/:token" element={<PublicMenu />} />
          <Route
            path="/post-property"
            element={
              <ProtectedRoute>
                <PostProperty />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/shortlist"
            element={
              <ProtectedRoute>
                <Shortlist />
              </ProtectedRoute>
            }
          />
          <Route
            path="/enquiries"
            element={
              <ProtectedRoute>
                <Enquiries />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stays"
            element={
              <ProtectedRoute>
                <Stays />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stays/collections"
            element={
              <ProtectedRoute>
                <Collections />
              </ProtectedRoute>
            }
          />
          <Route
            path="/stays/:id"
            element={
              <ProtectedRoute>
                <StayManage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rentals"
            element={
              <ProtectedRoute>
                <Rentals />
              </ProtectedRoute>
            }
          />
          <Route
            path="/rentals/:id"
            element={
              <ProtectedRoute>
                <StayManage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <Admin />
              </ProtectedRoute>
            }
          />
          <Route path="/:city/:intent" element={<CityLanding />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <FavoritesProvider>
          <AppRouter />
          <Toaster position="top-right" />
        </FavoritesProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
